import { render, staticRenderFns } from "./aaa.vue?vue&type=template&id=15fcf28f&"
import script from "./aaa.vue?vue&type=script&lang=js&"
export * from "./aaa.vue?vue&type=script&lang=js&"
import style0 from "./aaa.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports